import { create } from 'zustand';
import { api } from '../services/api';

export const useGamesStore = create((set, get) => ({
  // Журнал партий
  sessions: [],
  summary: { runs: 0, stars: 0, players: 0, score: 0, topPlayers: [] },
  total: 0,
  page: 1,
  totalPages: 1,
  isLoadingSessions: false,

  // Настройки игр
  games: [],
  isLoadingGames: false,

  error: null,
  success: null,

  // Номер страницы журнала. Принимает и значение, и updater-функцию,
  // как setState: кнопки пагинации считают следующую страницу от текущей,
  // а это выражение в стиле setPage((p) => p + 1), а не setPage(p + 1).
  setPage: (next) =>
    set((state) => {
      const value = typeof next === 'function' ? next(state.page) : next;
      const page = Number(value);
      return { page: Number.isFinite(page) ? Math.max(1, page) : 1 };
    }),

  // Загрузка журнала партий
  fetchSessions: async (params = {}) => {
    set({ isLoadingSessions: true, error: null });
    try {
      const data = await api.getGameSessions(params);
      set({
        sessions: data.sessions || [],
        total: data.total || 0,
        page: data.page || 1,
        totalPages: data.totalPages || 1,
        isLoadingSessions: false,
      });
      return data;
    } catch (error) {
      set({ error: error.message, isLoadingSessions: false });
      return null;
    }
  },

  // Сводка по журналу (те же фильтры, что и у таблицы)
  fetchSummary: async (params = {}) => {
    try {
      const data = await api.getGamesSummary(params);
      set({
        summary: {
          runs: data.runs || 0,
          stars: data.stars || 0,
          players: data.players || 0,
          score: data.score || 0,
          topPlayers: data.topPlayers || [],
        },
      });
      return data;
    } catch (error) {
      set({ error: error.message });
      return null;
    }
  },

  // Загрузка игр с порогами наград
  fetchGames: async () => {
    set({ isLoadingGames: true, error: null });
    try {
      const data = await api.getGames();
      set({ games: data.games || [], isLoadingGames: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoadingGames: false });
      return null;
    }
  },

  // Сохранить игру и её пороги
  saveGame: async (gameId, payload) => {
    set({ error: null, success: null });
    try {
      const data = await api.updateGame(gameId, payload);
      // Ответ содержит актуальное состояние игры — подменяем строку,
      // чтобы сервер остался единственным источником истины (id порогов).
      set((state) => ({
        games: state.games.map((game) => (game.game_id === gameId ? data.game : game)),
        success: data.message || 'Сохранено',
      }));
      return { success: true };
    } catch (error) {
      set({ error: error.message });
      return { success: false, error: error.message };
    }
  },

  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
}));
